/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import {ROLES_KEY} from '@/graphql'
import i18n from "@/i18n";

let AllRoutes = [
  {
    url: i18n.t('menu.dashboad.url'),
    name: i18n.t('menu.dashboad.name'),
    slug: i18n.t('menu.dashboad.slug'),
    icon: "HomeIcon",
    role: ["manager", "center", "admin", "user", "kvsupport"]

  },
  {
    url: i18n.t('menu.students.url'),
    name: i18n.t('menu.students.name'),
    slug: i18n.t('menu.students.slug'),
    icon: "DatabaseIcon",
    role: ["manager", "center", "admin", "kvsupport"]

  },
  {
    url: i18n.t('menu.users.menu_path'),
    name: i18n.t('menu.users.name'),
    slug: i18n.t('menu.users.slug'),
    icon: "UsersIcon",
    role: ["manager", "center", "admin", "kvsupport"]

  },
  {
    url: i18n.t('menu.managers.url'),
    name: i18n.t('menu.managers.name'),
    slug: i18n.t('menu.managers.slug'),
    icon: "AwardIcon",
    role: ["center", "admin", "kvsupport"]

  },
  {
    url: i18n.t('menu.incidents.menu_path'),
    name: i18n.t('menu.incidents.name'),
    slug: i18n.t('menu.incidents.slug'),
    icon: "GridIcon",
    role: ["admin","manager","kvsupport","center"]
  },
  {
    url: i18n.t('menu.tickets.menu_path'),
    name: i18n.t('menu.tickets.name'),
    slug: i18n.t('menu.tickets.slug'),
    icon: "CheckSquareIcon",
    role: ["admin","manager","kvsupport","center"]
  },
  {
    url: i18n.t('menu.reports.url'),
    name: i18n.t('menu.reports.name'),
    role: ["center", "admin", "kvsupport"],
    // tag: '2',
    // tagColor: 'warning',
    icon: 'FileIcon',
    submenu: [
      {
        url: i18n.t('menu.daily_logins.url'),
        name: i18n.t('menu.daily_logins.name'),
        slug: i18n.t('menu.daily_logins.slug'),
      },
      {
        url: i18n.t('menu.daily_watch_time.url'),
        name: i18n.t('menu.daily_watch_time.name'),
        slug: i18n.t('menu.daily_watch_time.slug'),
      },
      {
        url: i18n.t('menu.logs.url'),
        name: i18n.t('menu.logs.name'),
        slug: i18n.t('menu.logs.slug'),
      },
    ]
  },
  {
    url: i18n.t('menu.students_user.url'),
    name: i18n.t('menu.students_user.name'),
    slug: i18n.t('menu.students_user.slug'),
    icon: "DatabaseIcon",
    role: ["user"]

  },
  {
    url: i18n.t('menu.settings.url'),
    name: i18n.t('menu.settings.name'),
    role: ["center", "admin","kvsupport"],
    icon: 'SettingsIcon',
    submenu: [
      {
        url: i18n.t('menu.locations.url'),
        name: i18n.t('menu.locations.name'),
        slug: i18n.t('menu.locations.slug'),
      },
      {
        url: i18n.t('menu.programs.url'),
        name: i18n.t('menu.programs.name'),
        slug: i18n.t('menu.programs.slug'),
      },
      // {
      //   url: i18n.t('menu.cameras.url'),
      //   name: i18n.t('menu.cameras.name'),
      //   slug: i18n.t('menu.cameras.slug'),
      // },
      {
        url: i18n.t('menu.schedules.url'),
        name: i18n.t('menu.schedules.name'),
        slug: i18n.t('menu.schedules.slug'),
      }, {
        url: i18n.t('menu.theme_customizer.url'),
        name: i18n.t('menu.theme_customizer.name'),
        slug: i18n.t('menu.theme_customizer.slug'),
        role: ["admin"]
      },
    ]
  },
  {
    url: i18n.t('menu.admins.url'),
    name: i18n.t('menu.admins.name'),
    slug: i18n.t('menu.admins.slug'),
    icon: "UsersIcon",
    role: ["admin"]

  },

  ]

let user_roles = []

let Menu = []
let user_roles_array = []

if(localStorage.getItem(ROLES_KEY)){

  // console.log(localStorage.getItem(ROLES_KEY))
  user_roles = localStorage.getItem(ROLES_KEY)


 user_roles_array = JSON.parse(user_roles).map(function(value,index) { return value['name']; });

}


for (let i in AllRoutes)
{

  if (user_roles_array.some(value =>  AllRoutes[i].role.includes(value))){
    Menu.push(AllRoutes[i])
  }
}

export default
  Menu

